export const paywallTriggerActionIds = {
  batchProcessing: 'batch_processing_cta_popup_try_subscribe_tapped',
  paywallSelectionHighlighted: 'paywall_selection_highlighted_selected',
  paywallSelectionOther: 'paywall_selection_other_selected',
  outputFormatConversion:
    'output_format_conversion_cta_popup_try_subscribe_tapped',
  videoUpload: 'video_upload_cta_popup_try_subscribe_tapped',
} as const;

export function isPaywallTriggerActionId(actionId?: string) {
  return Object.values(paywallTriggerActionIds).some(
    (paywallTriggerActionId) => paywallTriggerActionId === actionId
  );
}
